import { CDN_URL } from 'src/utils/helper/misc'

export const PROMOTIONS = [
  {
    promoTitle: 'Sign it now to get access to unlock all features.',
    expire: 'Ends in * year * months * days'
  },
  {
    promoTitle: 'Sign it now to get access to make most of our platform.',
    expire: 'Ends in * days'
  },
  {
    promoTitle: 'Unlock all features by signing the latest agreement.',
    expire: 'Ends in * year * months * days'
  },
  {
    promoTitle: 'Unlock all features by signing the latest agreement.',
    expire: 'Ends in * days'
  },
  {
    promoTitle: 'Sign it now to make the most of the Foundry platform.',
    expire: 'Ends in * months * days'
  }
]

export const BUNDLES = [
  {
    bundleTitle: 'Sign it now to get access to unlock all features.',
    expire: 'Ends in * year * months * days'
  },
  {
    bundleTitle: 'Sign it now to get access to make most of our platform.',
    expire: 'Ends in * days'
  },
  {
    bundleTitle: 'Unlock all features by signing the latest agreement.',
    expire: 'Ends in * year * months * days'
  },
  {
    bundleTitle: 'Unlock all features by signing the latest agreement.',
    expire: 'Ends in * days'
  },
  {
    bundleTitle: 'Sign it now to make the most of the Foundry platform.',
    expire: 'Ends in * months * days'
  }
]

export const BLUR_REPORT = {
  earning: {
    total: '$$$.$$',
    date: 'MM DD, YYYY',
    highest_sales: '$$$.$$',
    family: 'My Test Family',
    family_amount: '$$$.$$',
    license: 'license',
    license_amount: '$$$.$$'
  },
  order: {
    total: '**',
    count: '**',
    platform: 'platform',
    country: 'country'
  }
}
export const REPORT_EARNING_TYPE = 'earnings'

export const CMS = {
  readmore: 'Read More',
  primary: {
    mainTitle: 'Articles and videos',
    articles: [
      {
        subTitle: 'Sign UFDA2',
        title: 'Unlock all features by signing the latest agreement.',
        description: 'Unlock all features by signing the latest agreement.',
        img: `${CDN_URL}/fe-static-content/img1.jpeg`
      },
      {
        subTitle: 'Sign UFDA2',
        title: 'Unlock all features by signing the latest agreement.',
        description: 'Unlock all features by signing the latest agreement.',
        img: `${CDN_URL}/fe-static-content/img2.jpeg`
      },
      {
        subTitle: 'Sign UFDA2',
        title: 'Unlock all features by signing the latest agreement.',
        description: 'Unlock all features by signing the latest agreement.',
        img: `${CDN_URL}/fe-static-content/img3.jpeg`
      }
    ]
  },
  secondary: {
    mainTitle: 'Learn more about the business of fonts',
    articles: [
      {
        subTitle: 'Sign UFDA2',
        title: 'Unlock all features by signing the latest agreement.',
        description: 'Unlock all features by signing the latest agreement.',
        img: `${CDN_URL}/fe-static-content/img4.jpeg`
      },
      {
        subTitle: 'Sign UFDA2',
        title: 'Unlock all features by signing the latest agreement.',
        description: 'Unlock all features by signing the latest agreement.',
        img: `${CDN_URL}/fe-static-content/img5.jpeg`
      },
      {
        subTitle: 'Sign UFDA2',
        title: 'Unlock all features by signing the latest agreement.',
        description: 'Unlock all features by signing the latest agreement.',
        img: `${CDN_URL}/fe-static-content/img6.jpg`
      }
    ]
  }
}

export const BLUR_TOP_PERFORMERS = [
  {
    familyName: 'Sign UFDA 2',
    orderQuantity: '****',
    saleAmount: '$$$$.$$',
    width: '92.00021999692005%'
  },
  {
    familyName: 'SignUFDA2',
    orderQuantity: '****',
    saleAmount: '$$$$.$$',
    width: '70.0092005%'
  },
  {
    familyName: 'Non Ufda2',
    orderQuantity: '****',
    saleAmount: '$$$$.$$',
    width: '55.00022005%'
  },
  {
    familyName: 'SignUFDA2',
    orderQuantity: '****',
    saleAmount: '$$$$.$$',
    width: '30.00021905%'
  },
  {
    familyName: 'No UFDA2',
    orderQuantity: '****',
    saleAmount: '$$$$.$$',
    width: '25.0002005%'
  }
]
